import {Component, OnDestroy, OnInit} from '@angular/core';
import {SemanticsService} from '../../../services/semantic/semantics.service';
import {SpeechToTextService} from '../../../services/speech-to-text/speech-to-text.service';

@Component({
  selector: 'app-semantics',
  templateUrl: './semantics.component.html',
  styleUrls: ['../../../app.component.scss', './semantics.component.scss']
})
export class SemanticsComponent implements OnInit, OnDestroy {
  text = '';
  resultsStr = '';
  results: any;
  textArea: any;

  constructor(public semanticsService: SemanticsService, public speechToTextService: SpeechToTextService) {

  }

  ngOnInit() {
    setTimeout(() => {
      this.initSpeech();
    }, 100); // Needed a little bit delay
  }

  ngOnDestroy(): void {
    if (this.speechToTextService.supportSpeech()) {
      this.speechToTextService.stop();
    }
  }

  clearText() {
    this.text = '';
    this.speechToTextService.clearText();
  }

  startSpeech() {
    this.speechToTextService.start(this.text);
  }

  initSpeech() {
    this.textArea = document.getElementById('text') as any;
    const textInterim = document.getElementById('textInterim') as any;
    this.speechToTextService.onUpdateSpeechText = (finalTranscript: string, interimTranscript: string) => {
      textInterim.innerHTML = interimTranscript;
      if (finalTranscript !== this.text) {
        this.textArea.value = this.text = finalTranscript;
        setTimeout(() => {
          this.textArea.focus();
          this.textArea.scrollTop = this.textArea.scrollHeight;
        }, 200);

        this.analysis();
      }
    };
    const startImg = document.getElementById('start_img') as any;
    this.speechToTextService.onUpdateImage = (imgUrl: string) => {
      startImg.src = imgUrl;
    };
    const infoDiv = document.getElementById('info') as any;
    this.speechToTextService.onUpdateInfo = (infoText: string, classes: any) => {
      infoDiv.innerHTML = infoText;
    };

    this.speechToTextService.init();
  }

  changeLanguage(language: string) {
    if (language === 'en') {
      this.semanticsService.setEnglishLanguage();
      this.speechToTextService.setEnglishLanguage();
    } else if (language === 'gr') {
      this.semanticsService.setGreekLanguage();
      this.speechToTextService.setGreekLanguage();
    }
  }

  analysis() {
    console.log(this.text);
    if (!this.semanticsService.isBusy) {
      this.semanticsService.sendTextForAnalysis(this.text, (data: any) => {
        this.resultsStr = JSON.stringify(data);
        this.results = data;
      });
    }
  }

}
